// extracted by mini-css-extract-plugin
export default {"list":"i7ZNOl","newListGap":"C2ncMV","mobileList":"HmedbB","listPaddingTop":"AIk0y2","basketViewDesktop":"Qq58Dd"};